let handler: (() => void) | null = null;

export const registerOfflineNavigator = (fn: () => void) => {
  handler = fn;
};

export const unregisterOfflineNavigator = () => {
  handler = null;
};

export const navigateToOffline = (): boolean => {
  if (handler) {
    handler();
    return true;
  }
  return false;
};
